"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLegacyActionRecord = isLegacyActionRecord;
exports.isPatchBasedActionRecord = isPatchBasedActionRecord;
exports.isActionRecordWithActionArgs = isActionRecordWithActionArgs;
const patch_1 = require("./patch");
// TODO: do we need this to be stronger?  I don't think so.
function isLegacyActionRecord(actionRec) {
    return !isPatchBasedActionRecord(actionRec);
}
function isPatchBasedActionRecord(actionRec) {
    return ("type" in actionRec.actionChangeDiff && actionRec.actionChangeDiff.type === patch_1.ImmerBasedPatchTypes.patchSequence);
}
function isActionRecordWithActionArgs(actionRec) {
    return "actionArgs" in actionRec;
}
//# sourceMappingURL=actionRecord.js.map